import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Banner } from './components/layout/Banner';
import { AdminGuard } from './components/ui/AdminGuard';
import { Toaster } from './components/ui/Toaster';
import { EmptyState } from './components/ui/EmptyState';
import { Button } from './components/ui/Button';
import { CatalogPage } from './pages/CatalogPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { ProfilePage } from './pages/ProfilePage';
import { SettingsPage } from './pages/SettingsPage';

function AppContent() {
  const { pathname } = useLocation();
  const showBanner = pathname === '/';
  const logout = useAuthStore((s) => s.logout);

  useEffect(() => {
    const handleUnauthorized = () => logout();
    window.addEventListener('unauthorized', handleUnauthorized);
    return () => window.removeEventListener('unauthorized', handleUnauthorized);
  }, [logout]);

  return (
    <div className="min-h-screen bg-champagne-light flex flex-col">
      <Header />
      {showBanner && <Banner src="/banner-3.png" alt="Baby Chic — Novidades da coleção" />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<CatalogPage />} />
          <Route path="/produtos/:id" element={<ProductDetailPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/cadastro" element={<RegisterPage />} />
          <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
          <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
          <Route path="/perfil" element={<ProfilePage />} />
          <Route path="/configuracoes" element={<AdminGuard><SettingsPage /></AdminGuard>} />
          <Route
            path="*"
            element={
              <div className="max-w-2xl mx-auto px-4 py-8">
                <EmptyState
                  title="Página não encontrada"
                  description="A página que você tentou acessar não existe ou foi removida."
                  action={<Link to="/"><Button>Voltar para a loja</Button></Link>}
                />
              </div>
            }
          />
        </Routes>
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
